import { useAdminUpdate } from '@reapitform/hooks'
import { AdminRecipientCard, AdminRecipientCardPayload } from '../types'

/** Creates a recipient card under a recipient step (`POST /recipient-steps/{stepRef}/cards`). */
export const useCreateAdminRecipientCard = (recipientStepReferenceID: string) =>
  useAdminUpdate<AdminRecipientCardPayload, AdminRecipientCard>({
    path: `/api/recipient-steps/${recipientStepReferenceID}/cards`,
    method: 'POST',
    errorMessage: 'Failed to create the recipient card',
    successMessage: 'Recipient card created',
  })
